import { configureReanimatedLogger, ReanimatedLogLevel } from "react-native-reanimated";

// https://docs.swmansion.com/react-native-reanimated/docs/debugging/logger-configuration/
configureReanimatedLogger({
    level: ReanimatedLogLevel.warn,
    // Warnings seem to be fixed by https://github.com/kirillzyusko/react-native-keyboard-controller/pull/662
    // But they are still present today
    strict: false,
});
